module.exports = __webpack_public_path__ + "media/images/bundle-lite@2x-886a8dbef4a73c1574e20d5138c6708d.png";